import {
  INITIAL_LOADER,
  LOGOUT_USER,
  SUCCESS_SUPER_ADMIN,
} from "../actions/auth";

const initialState = {
  userData: null,
  accessToken: null,
  refreshToken: null,
  initialLoading: true,
};
const initialStateLogout = {
  userData: null,
  accessToken: null,
  refreshToken: null,
  initialLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case INITIAL_LOADER:
      return { ...state, initialLoading: action.payload };
    case "SET_USER":
      const { accessToken: aT, refreshToken: rT, userData: uD } = action;

      return {
        ...state,
        accessToken: aT,
        refreshToken: rT,
        userData: uD,
        initialLoading: false,
      };
    case "SIGNIN_USER":
      return {
        ...state,
      };
    case SUCCESS_SUPER_ADMIN:
      const { userData, accessToken, refreshToken } = action;
      return { ...state, userData, accessToken, refreshToken };
    case LOGOUT_USER:
      return initialStateLogout;

    default:
      return state;
  }
};
